import moment from 'moment';
import { GRADIENT_THEMES } from '../theme/litvikBrand';

export { GRADIENT_THEMES };

export const buildGradientCard = (label, value, theme = 'blue') => ({
    label,
    value: String(value),
    ...(GRADIENT_THEMES[theme] || GRADIENT_THEMES.blue),
});

export const sumField = (records, field) =>
    (records || []).reduce((sum, row) => sum + (Number(row[field]) || 0), 0);

export const formatQty = (value) => Number(value || 0).toFixed(2);

export const isInactiveRecord = (row) => {
    if (row?.is_inactive === true) {
        return true;
    }
    if (row?.is_inactive === false) {
        return false;
    }
    const status = row?.status ?? row?.status_2;
    if (typeof status === 'boolean') {
        return !status;
    }
    const normalized = String(status || '').trim().toUpperCase();
    return normalized === 'INACTIVE' || normalized === 'CANCELLED' || normalized === 'FALSE' || normalized === '0';
};

export const normalizeListDate = (value) => {
    if (!value) {
        return '';
    }
    const parsed = moment(value, ['DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : String(value).trim();
};

export const isSameListDate = (left, right) => normalizeListDate(left) === normalizeListDate(right);
